<button class="btn btn-white btn-filters" (click)="toggleGroup($event)">
  @for (sort of sortOptions; track sort) {
    @if (sort.selected) {
      {{ sort.name}}
    }
  }
  <app-custom-icons [class]="!isVisible ? 'icon-arrow ' : 'icon-arrow rotate'" [type]="iconTypes.ARROW_DOWN_ICON">
  </app-custom-icons>
</button>

@if (isVisible) {
  <div class="inner-facets {{isVisible ? 'is-open' : ''}}">
    <div class="facet-modal is-open">
      <div class="facet-modal-header">
        <h2 class="facet-modal-title">{{'productList.sortBy' | cxTranslate}}</h2>
        <div class="close" (click)="toggleGroup($event)">
          <span aria-hidden="true">
            <app-custom-icons [type]="iconTypes.CLOSE"></app-custom-icons>
          </span>
        </div>
      </div>
      <div class="facets-elements facet-modal-body">
        @for (sort of sortOptions; track sort) {
          <div [class]="sort.selected ? 'facet-option selected' : 'facet-option'"
            (click)="sortCustomList(sort.code, sort.name ); toggleGroup($event)">
            {{ sort.name}}
          </div>
        }
      </div>
    </div>
  </div>
}

<!--  <div class="sorting-header">-->
<!--    <h2 class="sorting-title">{{'productList.sortBy' | cxTranslate}}</h2>-->
<!--    <div class="close" (click)="closeModal()">-->
<!--          <span aria-hidden="true">-->
<!--            <app-custom-icons [type]="iconTypes.CLOSE"></app-custom-icons>-->
<!--          </span>-->
<!--    </div>-->
<!--  </div>-->

<!--  <ng-select-->
<!--  #orderable-->
<!--  [searchable]="false"-->
<!--  [clearable]="false"-->
<!--  placeholder="{{ placeholder }}"-->
<!--  (change)="sortList($event)"-->
<!--  [ngModel]="selectedOption"-->
<!--  [attr.aria-label]="selectedLabel || placeholder"-->
<!--  (click)="openModal()"-->
<!--&gt;-->
<!--  <ng-option *ngFor="let sort of sortOptions" [value]="sort.code">{{-->
<!--    sort.name ? sort.name : sortLabels ? sortLabels[sort.code] : ''-->
<!--    }}</ng-option>-->
<!--</ng-select>-->
<!--</div>-->
